import { useQuery } from "@tanstack/react-query";

import { getPracticeManagementVersionNotes } from "services";

import { PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSION_NOTES } from "consts";

export const useGetPracticeManagementVersionNotes = () =>
  useQuery({
    queryKey: [PRACTICE_MANAGEMENT, PRACTICE_MANAGEMENT_VERSION_NOTES],
    queryFn: () => getPracticeManagementVersionNotes(),
    staleTime: 1000 * 60 * 60, // 1h
    gcTime: 1000 * 60 * 24, // 24h
  });
